import { Box, Chip } from '@mui/material';
import { FilterItem } from '../../../interfaces/filterOptions.interface';
import style from './style';

type TableFiltersItem = {
  filters: FilterItem[],
  onDelete: (filterItem: FilterItem) => void
}

const TableFiltersItems = ({ filters, onDelete }: TableFiltersItem): JSX.Element | null => {
  const renderFilterItem = (filterItem: FilterItem): JSX.Element => {
    return (
      <Chip
        key={ filterItem.value }
        label={ (
          <Box sx={ style.label.sx }>
            <span>
              {filterItem.label}
            </span>
            :
            {' '}
            {filterItem.displayValue || filterItem.value}
          </Box>
        ) }
        onDelete={ (): void => onDelete(filterItem) }
        sx={ style.chip.sx }
        variant={ style.chip.variant }
      />
    );
  };

  if (!filters.length) {
    return null;
  }

  return (
    <Box sx={ style.main.sx }>
      { filters.map((filterItem) => renderFilterItem(filterItem)) }
    </Box>
  );
};

export default TableFiltersItems;
